import { useState } from 'react';
import { Flex } from 'antd';
import { MButton, MCheckbox } from '@Components/Base';
import { InfoCard } from '@Features/MaterialRequest/requests/components/InfoCard';
import { NoData } from '@Features/MaterialRequest/requests/components/NoData';
import { PurchaseItemResponse } from '@Types/api/form';
import { ReactComponent as DeleteIcon } from '@Icons/additional/trash-gradient.svg';

import styles from './OverviewMaterialsContent.module.css';

interface OverviewContentProps {
  overviewItems: PurchaseItemResponse[];
  selectedOverviewItems: PurchaseItemResponse[];
  handleAddMaterial: (purchaseItem: PurchaseItemResponse) => void;
  handleRemoveMaterial: (purchaseItem: PurchaseItemResponse) => void;
  handleRemoveAllMaterial: () => void;
  handleSelectOverviewItem: (purchaseItem: PurchaseItemResponse) => void;
  handleUnselectOverviewItem: (purchaseItem: PurchaseItemResponse) => void;
  handleUnselectAllOverviewItems: () => void;
  handleSelectAllOverviewItems: () => void;
}

const OverviewContent: React.FC<OverviewContentProps> = ({
  overviewItems,
  selectedOverviewItems,
  handleRemoveAllMaterial,
  handleRemoveMaterial,
  handleSelectAllOverviewItems,
  handleSelectOverviewItem,
  handleUnselectOverviewItem,
  handleUnselectAllOverviewItems,
}) => {
  const [selectedAll, setSelectedAll] = useState(false);

  const isEmpty = !overviewItems.length;

  return (
    <div className={styles.container}>
      {isEmpty ? (
        <Flex className={styles.noData} align="center">
          <NoData
            context="empty-materials"
            isFiltersApplied={false}
            isSearchApplied={false}
          />
        </Flex>
      ) : (
        <>
          <div className={styles.header}>
            <MCheckbox
              onChange={(e) => {
                if (e.target.checked) {
                  handleSelectAllOverviewItems();
                  setSelectedAll(true);
                } else {
                  handleUnselectAllOverviewItems();
                  setSelectedAll(false);
                }
              }}
              checked={selectedAll}
            >
              <b>{selectedOverviewItems?.length} MATERIALS</b> selected
            </MCheckbox>
            <MButton
              className={styles.removeButton}
              type="text"
              onClick={handleRemoveAllMaterial}
            >
              Remove All
            </MButton>
          </div>
          <Flex vertical gap={16}>
            {overviewItems.map((item) => (
              <InfoCard
                key={item.reqItemId}
                title={
                  <div className={styles.cardHeader}>
                    <MCheckbox
                      onChange={(e) => {
                        if (e.target.checked) {
                          handleSelectOverviewItem(item);
                        } else {
                          setSelectedAll(false);
                          handleUnselectOverviewItem(item);
                        }
                      }}
                      checked={
                        !!selectedOverviewItems.find(
                          (selectedItem) =>
                            selectedItem?.reqItemId === item?.reqItemId
                        )
                      }
                    >
                      <span
                        title={String(item.matDesc)}
                        className={styles.cardTitle}
                      >
                        {String(item.matDesc)}
                      </span>
                    </MCheckbox>
                    <MButton
                      className={styles.cardButton}
                      type="text"
                      onClick={() => handleRemoveMaterial(item)}
                    >
                      <DeleteIcon />
                    </MButton>
                  </div>
                }
                items={[
                  {
                    label: `PR No. ${item.reqID}`,
                    value: '',
                  },
                  {
                    label: 'Material Code',
                    value: String(item.matCode),
                  },
                  {
                    label: 'Qty.',
                    value: String(item.reqQty),
                  },
                ]}
              />
            ))}
          </Flex>
        </>
      )}
    </div>
  );
};

export default OverviewContent;
